import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "@/i18n";
import { routes } from "./routes";
import configuration from "@/features/configuration";
import Authenticator from "@/components/Authenticator";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const router = createBrowserRouter(routes);
// Avoid refetch queries when tab regains focus or reconnects to the internet
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Authenticator authConfig={configuration.authenticationConfig}>
        <RouterProvider router={router} />
      </Authenticator>
    </QueryClientProvider>
  );
}
